export default {
// fil-PH.js
help: {
  faq: "FAQ",
  promo: "Promo",
  contactUs: "Makipag-ugnayan sa Amin",
  joinCommunity: "Sumali sa Aming Komunidad",
  help: "Tulong"
}
};
